var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("员工列表")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "Box" }, [
        _c("div", { staticClass: "table_tab" }, [
          _c(
            "div",
            { staticClass: "inquiry" },
            [
              _c("div", { staticClass: "headerbox" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "headerbox_right" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.refresh()
                          },
                        },
                      },
                      [_vm._v("刷新")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.back()
                          },
                        },
                      },
                      [_vm._v("返回")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "headerTitle" }, [_vm._v("数据筛选")]),
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: {
                    inline: true,
                    model: _vm.queryForm,
                    "label-width": "",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "昵称" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.queryForm.reallyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "reallyName", $$v)
                          },
                          expression: "queryForm.reallyName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "工作手机号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.queryForm.workPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "workPhone", $$v)
                          },
                          expression: "queryForm.workPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.queryForm.phoneNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "phoneNumber", $$v)
                          },
                          expression: "queryForm.phoneNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "旧五域账号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.queryForm.oldAccount,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "oldAccount", $$v)
                          },
                          expression: "queryForm.oldAccount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "工号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.queryForm.serial,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "serial", $$v)
                          },
                          expression: "queryForm.serial",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "部门" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.options,
                          "show-all-levels": false,
                          props: {
                            checkStrictly: true,
                            label: "orgName",
                            value: "orgCode",
                            children: "children",
                          },
                          clearable: "",
                          filterable: "",
                        },
                        on: { change: _vm.handleSelectOrgId },
                        model: {
                          value: _vm.queryForm.orgId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "orgId", $$v)
                          },
                          expression: "queryForm.orgId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "职位" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.handleSelectPositionId },
                          model: {
                            value: _vm.queryForm.positionId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "positionId", $$v)
                            },
                            expression: "queryForm.positionId",
                          },
                        },
                        _vm._l(_vm.positionList, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: { label: items.name, value: items.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "角色" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.handleSelectRoleId },
                          model: {
                            value: _vm.queryForm.roleId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "roleId", $$v)
                            },
                            expression: "queryForm.roleId",
                          },
                        },
                        _vm._l(_vm.roleDataList, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: { label: items.name, value: items.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "在职" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: { change: _vm.handleSelectStatus },
                          model: {
                            value: _vm.queryForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "status", $$v)
                            },
                            expression: "queryForm.status",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.employee_status,
                          function (items) {
                            return _c("el-option", {
                              key: items.dictId,
                              attrs: {
                                label: items.dictName,
                                value: items.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.searchEvent("search")
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchEvent("search")
                            },
                          },
                        },
                        [_vm._v("搜索 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.reset()
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                      _vm.parArray.indexOf("ygAdd") != -1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.toInfo("add")
                                },
                              },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.parArray.indexOf("refreshUser") != -1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.toRefreshUser()
                                },
                              },
                            },
                            [_vm._v("刷新用户")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "inquiryTab" }, [
            _c("div", { staticClass: "tabTitle" }, [_vm._v("员工列表")]),
            _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      data: _vm.tableData.list,
                      "header-cell-style": { background: "#f8f8f8" },
                      align: "center",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "昵称",
                        "min-width": "120",
                        prop: "reallyName",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  staticClass: "btnp",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toInfo("view", props.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.reallyName) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "工作手机号",
                        prop: "workPhone",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "手机号",
                        prop: "phoneNumber",
                        "min-width": "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(props.row.phoneNumber)),
                              ]),
                              _c("div", [
                                _vm._v(
                                  "手机号1: " +
                                    _vm._s(props.row.extraPhoneFirst || "--")
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  "手机号2: " +
                                    _vm._s(props.row.extraPhoneSecond || "--")
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "工号", "min-width": "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.row.serial))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "性别",
                        prop: "sexLabel",
                        "min-width": "50",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "部门",
                        prop: "orgName",
                        "min-width": "80",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "职位",
                        prop: "positionName",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { width: "150", label: "角色" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return _vm._l(props.row.roleName, function (item) {
                              return _c("p", { key: item.index }, [
                                _vm._v(" " + _vm._s(item) + " "),
                              ])
                            })
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "150",
                        label: "旧五域账号",
                        prop: "oldAccount",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "200",
                        label: "最后更新时间",
                        prop: "updatedTime",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { width: "90", label: "在职状态", prop: "status" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  class:
                                    props.row.status == "A" ||
                                    props.row.status == "T" ||
                                    props.row.status == "W"
                                      ? "green"
                                      : "" || props.row.status == "S"
                                      ? "red"
                                      : "" || props.row.status == "X"
                                      ? "gray"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.statusLabel) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "150", fixed: "right" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm.parArray.indexOf("ygdetail") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toInfo("view", props.row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("userUpdate") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toInfo("edit", props.row)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("setPass") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.setPassword(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 设置密码 ")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("ygPhone") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.setPhone(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 设置工作手机号 ")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("staffLogin") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.staffLogin(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 登录后台")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("userDelete") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeEmployee(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm.tableData.totalNum > 0
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pageNo,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.addDialog.title,
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.toInfoDialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseToInfo,
          },
          on: {
            "update:visible": function ($event) {
              _vm.toInfoDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                rules: _vm.rulesAddOrUpdate,
                size: "mini",
                model: _vm.form,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "昵称", prop: "reallyName" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.userFixable },
                    model: {
                      value: _vm.form.reallyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reallyName", $$v)
                      },
                      expression: "form.reallyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工作手机号", prop: "workPhone" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.userFixable, maxLength: "11" },
                    model: {
                      value: _vm.form.workPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "workPhone", $$v)
                      },
                      expression: "form.workPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "phoneNumber" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.userFixable, maxLength: "11" },
                    model: {
                      value: _vm.form.phoneNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phoneNumber", $$v)
                      },
                      expression: "form.phoneNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号1", prop: "extraPhoneFirst" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.userFixable, maxLength: "11" },
                    model: {
                      value: _vm.form.extraPhoneFirst,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "extraPhoneFirst", $$v)
                      },
                      expression: "form.extraPhoneFirst",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号2", prop: "extraPhoneSecond" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.userFixable, maxLength: "11" },
                    model: {
                      value: _vm.form.extraPhoneSecond,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "extraPhoneSecond", $$v)
                      },
                      expression: "form.extraPhoneSecond",
                    },
                  }),
                ],
                1
              ),
              _vm.addDialog.type === "add"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "设置密码", prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: { type: "password", placeholder: "请输入密码" },
                        model: {
                          value: _vm.form.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "password", $$v)
                          },
                          expression: "form.password",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "工号", prop: "serial" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.userFixable },
                    model: {
                      value: _vm.form.serial,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "serial", $$v)
                      },
                      expression: "form.serial",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "性别", prop: "sex" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.userFixable,
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.sex,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sex", $$v)
                        },
                        expression: "form.sex",
                      },
                    },
                    _vm._l(_vm.dictionaries.employee_sex, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "部门", prop: "orgCode" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      disabled: _vm.userFixable,
                      options: _vm.options,
                      "show-all-levels": false,
                      props: {
                        checkStrictly: true,
                        label: "orgName",
                        value: "orgCode",
                        children: "children",
                      },
                      clearable: "",
                      filterable: "",
                    },
                    on: { change: _vm.handleFormOrgId },
                    model: {
                      value: _vm.form.orgCodes,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orgCodes", $$v)
                      },
                      expression: "form.orgCodes",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "职位", prop: "positionCode" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.userFixable,
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.positionCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "positionCode", $$v)
                        },
                        expression: "form.positionCode",
                      },
                    },
                    _vm._l(_vm.positionList, function (item) {
                      return _c("el-option", {
                        key: item.positionCode,
                        attrs: { label: item.name, value: item.positionCode },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "系统角色", prop: "autoRoleIds" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: "",
                        placeholder: "请选择",
                        clearable: "",
                        multiple: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.autoRoleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "autoRoleIds", $$v)
                        },
                        expression: "form.autoRoleIds",
                      },
                    },
                    _vm._l(_vm.roleDataList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "角色", prop: "roleIds" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.userFixable,
                        placeholder: "请选择",
                        clearable: "",
                        multiple: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.roleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "roleIds", $$v)
                        },
                        expression: "form.roleIds",
                      },
                    },
                    _vm._l(_vm.roleDataList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.addDialog.type !== "add"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "旧五域账号", prop: "sex" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.form.oldAccount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "oldAccount", $$v)
                          },
                          expression: "form.oldAccount",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "在职状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        disabled: _vm.userFixable,
                      },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    _vm._l(_vm.dictionaries.employee_status, function (items) {
                      return _c("el-option", {
                        key: items.dictId,
                        attrs: { label: items.dictName, value: items.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否员工", prop: "employeeFlag" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        disabled: _vm.addDialog.type !== "add",
                      },
                      model: {
                        value: _vm.form.employeeFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "employeeFlag", $$v)
                        },
                        expression: "form.employeeFlag",
                      },
                    },
                    _vm._l(_vm.employeeFlags, function (items) {
                      return _c("el-option", {
                        key: items.dictId,
                        attrs: { label: items.dictName, value: items.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.addDialog.type !== "view"
            ? _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.toInfoDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSaveUpdate },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置密码",
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.setPasswordDialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseSetPassword,
          },
          on: {
            "update:visible": function ($event) {
              _vm.setPasswordDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formPass",
              attrs: {
                rules: _vm.rulesSetPass,
                model: _vm.formPass,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设置密码", prop: "setPasswordDate" } },
                [
                  _c("el-input", {
                    attrs: { type: "password", placeholder: "请输入密码" },
                    model: {
                      value: _vm.formPass.setPasswordDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPass, "setPasswordDate", $$v)
                      },
                      expression: "formPass.setPasswordDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.setPasswordDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setPasswordConfirm("formPass")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "刷新用户",
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.refreshUserDialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseRefreshUser,
          },
          on: {
            "update:visible": function ($event) {
              _vm.refreshUserDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRU",
              attrs: {
                rules: _vm.rulesRefreshRU,
                model: _vm.formRU,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "刷新用户", prop: "phoneNumber" } },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入手机号" },
                    model: {
                      value: _vm.formRU.phoneNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.formRU, "phoneNumber", $$v)
                      },
                      expression: "formRU.phoneNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.refreshUserDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.refreshUserConfirm("formRU")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置工作手机号",
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.setPhoneDialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseSetPhone,
          },
          on: {
            "update:visible": function ($event) {
              _vm.setPhoneDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                rules: _vm.rulesSetPhone,
                model: _vm.ruleForm,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设置工作手机号", prop: "setPhoneDate" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "设置工作手机号",
                      autocomplete: "off",
                      maxLength: "11",
                    },
                    model: {
                      value: _vm.ruleForm.setPhoneDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "setPhoneDate", $$v)
                      },
                      expression: "ruleForm.setPhoneDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号1", prop: "extraPhoneFirst" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.userFixable, maxLength: "11" },
                    model: {
                      value: _vm.ruleForm.extraPhoneFirst,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "extraPhoneFirst", $$v)
                      },
                      expression: "ruleForm.extraPhoneFirst",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号2", prop: "extraPhoneSecond" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.userFixable, maxLength: "11" },
                    model: {
                      value: _vm.ruleForm.extraPhoneSecond,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "extraPhoneSecond", $$v)
                      },
                      expression: "ruleForm.extraPhoneSecond",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.setPhoneDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setPhoneConfirm("ruleForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title_left" }),
      _vm._v(" 员工 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }